window.app.controller('authCtrl', ['$http', '$scope', '$mdDialog', ($http, $scope, $mdDialog) => {
    $scope.showRegistrationSection = false;
    $scope.firstStepShow = true;
    $scope.successStepShow = false;
    $scope.checkInProgress = false;
    $scope.userMailAgentLink = '';
    $scope.user = {
        rememberMe: false,
        acceptTerms: false,
        acceptAdPolicy: false,
        acceptMailingPolicy: false
    };
    $scope.userExists = false;
    $scope.emailChecks = {};

    $scope.showMessage = () => {
        if (document.referrer.split('change-password').length > 1){
            return 'Hasło zmienione'
        }
    };

    $scope.changeHeader = () => {
        if($scope.showRegistrationSection) {
            return "Rejestracja nowego użytkownika";
        }
        return "Autoryzacja";
    };

    $scope.resendRegConfirmLetter = async (evt) => {
        // evt.preventDefault();

        try {
            // $scope.switchLoader(true);
            const res = await $scope.sendMessage();
        } catch (err) {
            console.error(err);
        }

    };

    $scope.mailRedirect = function() {
        window.location.href = $scope.userMailAgentLink;
    };


    $scope.sendMessage = () => {
        return $http({
            method: 'POST',
            url: '/api/front/registration/registration/resend-letter',
            data: {
                type: 'user',
                email: $scope.user.email
            }
        });
    };

    $scope.debug = () => {
        console.log($scope.authForm);
    };

    $scope.saveCheckResultInCache = data => {
        $scope.emailChecks[$scope.user.email] = data;
    };

    $scope.emailAlreadyChecked = () => {
        return typeof $scope.emailChecks[$scope.user.email] !== 'undefined';
    };

    $scope.collectFormData = () => {
        return $scope.needRegistration ? $scope.cpaClientData() : $scope.user;
    };

    $scope.cpaClientData = () => {
        return angular.extend($scope.user, {repeatPassword: $scope.user.repeatPassword})
    };

    $scope.$watch('user.password', function(){
        !$scope.user.password ? $scope.formErrorText = "" : "";
    })

    $scope.enterToOffice = response => {
        // console.log(response); return;
        if (response.data.authSuccess) {
            $scope.redirect(response.data.authUrl);
        }
        else if(response.data.registrationSuccess){
            $scope.successStepShow = true;
            $scope.firstStepShow = false;
        }

        $scope.formErrorText = response.data.message;
        $scope.formErrorLink = response.data.link;

        //TODO uncomment these lines when failed tries limitations are to be applied
        // if(loginResponse.loginFail){
        //     window.location.pathname = 'auth/password-form/';
        // }
    };
    $scope.login = () => {
      $scope.formErrorText = '';
      $scope.formErrorLink = '';
      $scope.user.type = 'user';
      if($scope.user.acceptTerms === true) {
        $scope.user.accept_terms = +$scope.user.acceptTerms;
        $scope.user.accept_personal_data_terms = +$scope.user.acceptAdPolicy;
        $scope.user.accept_mailing_policy = +$scope.user.acceptMailingPolicy;
        $scope.sendXHR({
          url: '/api/front/registration/registration/register',
          data: $scope.user,
          successFunc: $scope.enterToOffice
        })
      } else {
        $scope.sendXHR({
          url: '/api/front/authorization/authorization/authorize',
          data: $scope.user,
          successFunc: $scope.enterToOffice
        })
      }
    };
}]);



// WEBPACK FOOTER //
// src/js/controllers/user/authCtrl.js